var _a;
import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "tab-bar";
var attributes = {
    ACTIVE_TAB: 'active-tab',
    LAYOUT_MODE: 'layout-mode',
    LAYOUT_ALIGN: 'layout-align',
    UNDERLINE: 'underline',
    AUTO_ACTIVATE: 'auto-activate',
    FOCUS_ON_ACTIVATE: 'focus-on-activate',
    STACKED: 'stacked',
    SCROLL_BUTTONS: 'scroll-buttons',
    FORCE_SCROLL_BUTTONS: 'force-scroll-buttons'
};
var classes = {
    UNDERLINED: 'tyl-tab-bar--underlined',
    ALIGN_CENTER: 'tyl-tab-bar--align-center',
    ALIGN_END: 'tyl-tab-bar--align-end',
    FIXED: 'tyl-tab-bar--fixed',
    STACKED: 'tyl-tab-bar--stacked'
};
var selectors = {
    ROOT: '.tyl-tab-bar',
    TAB_SCROLLER: '.mdc-tab-scroller',
    TAB_SCROLLER_AREA: '.mdc-tab-scroller__scroll-area',
    TAB_SCROLLER_CONTENT: '.mdc-tab-scroller__scroll-content',
    PREV_BUTTON_CONTAINER: '.tyl-tab-bar__scroll-prev-container',
    PREV_BUTTON: '#scroll-prev-btn',
    NEXT_BUTTON_CONTAINER: '.tyl-tab-bar__scroll-next-container',
    NEXT_BUTTON: '#scroll-next-btn'
};
var events = {
    ACTIVATE: elementName + "-activate"
};
var strings = {
    ARROW_LEFT_KEY: 'ArrowLeft',
    ARROW_RIGHT_KEY: 'ArrowRight',
    END_KEY: 'End',
    ENTER_KEY: 'Enter',
    HOME_KEY: 'Home',
    SPACE_KEY: 'Space',
};
var numbers = {
    ARROW_LEFT_KEYCODE: 37,
    ARROW_RIGHT_KEYCODE: 39,
    END_KEYCODE: 35,
    ENTER_KEYCODE: 13,
    EXTRA_SCROLL_AMOUNT: 20,
    HOME_KEYCODE: 36,
    SPACE_KEYCODE: 32
};
export var TAB_BAR_CONSTANTS = {
    attributes: attributes,
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    events: events,
    strings: strings,
    numbers: numbers
};
export var ACCEPTABLE_KEYS = [
    strings.ARROW_LEFT_KEY,
    strings.ARROW_RIGHT_KEY,
    strings.END_KEY,
    strings.HOME_KEY,
    strings.ENTER_KEY,
    strings.SPACE_KEY
];
export var KEYCODE_MAP = (_a = {},
    _a[numbers.ARROW_LEFT_KEYCODE] = strings.ARROW_LEFT_KEY,
    _a[numbers.ARROW_RIGHT_KEYCODE] = strings.ARROW_RIGHT_KEY,
    _a[numbers.END_KEYCODE] = strings.END_KEY,
    _a[numbers.HOME_KEYCODE] = strings.HOME_KEY,
    _a[numbers.ENTER_KEYCODE] = strings.ENTER_KEY,
    _a[numbers.SPACE_KEYCODE] = strings.SPACE_KEY,
    _a);
